var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActions = function SvgActions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#1EBEAA",
    fillOpacity: 0.1,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1EBEAA",
    d: "M24.583 27.5a2.917 2.917 0 1 1 0-5.833 2.917 2.917 0 0 1 0 5.833Zm0-1.667a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm-9.166-7.5a2.916 2.916 0 1 1 0-5.832 2.916 2.916 0 0 1 0 5.832Zm0-1.666a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm10.475-3.738 1.179 1.178-12.963 12.964-1.178-1.179L25.892 12.93Z"
  })));
};
export default SvgActions;